"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MEDICATION_CODE_PATTERN () {
        return MEDICATION_CODE_PATTERN;
    },
    get MEDICATION_FORMS () {
        return MEDICATION_FORMS;
    },
    get MedicationCodeSchema () {
        return MedicationCodeSchema;
    },
    get MedicationFormSchema () {
        return MedicationFormSchema;
    },
    get SOLID_MEDICATION_FORMS () {
        return SOLID_MEDICATION_FORMS;
    }
});
const _zod = require("zod");
const MEDICATION_CODE_PATTERN = /^PNF-[0-9]{5}$/;
const MedicationCodeSchema = _zod.z.string().regex(MEDICATION_CODE_PATTERN, {
    message: 'Invalid medication code format.'
});
const MEDICATION_FORMS = [
    'tablet',
    'capsule',
    'syrup',
    'suspension',
    'solution',
    'drops',
    'sachet',
    'injection',
    'cream',
    'ointment',
    'gel',
    'lotion',
    'suppository',
    'inhaler',
    'nebule',
    'patch',
    'spray',
    'shampoo',
    'powder',
    'other'
];
const MedicationFormSchema = _zod.z.enum(MEDICATION_FORMS);
const SOLID_MEDICATION_FORMS = [
    'tablet',
    'capsule'
];
